import PropTypes from 'prop-types'
import { DriverKeyTypes } from '../../models/drivers/driver-key-types-enum'

/**
 * This is the type definition for the driver key type. It abstracts the lookup of the key type in the
 * available driver key types
 */
export const driverKeyTypePropType = PropTypes.oneOf([...Object.values(DriverKeyTypes), 'UNKNOWN'])
